import { Badge } from '../ui/badge';

export function PartOfSpeechBadge({ partOfSpeech }: { partOfSpeech: string }) {
  return (
    <Badge variant="secondary" className="capitalize mb-0 font-medium">
      {partOfSpeech}
    </Badge>
  );
}
